module.exports = __webpack_public_path__ + "media/assets/images/column-thumbnail_bicycle-5111ce4641924aef01978695767ea91f.png";